import { Icon, UiLink } from '@nexus/ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useModules } from '../modules/context';
import { buildNavigation } from '../modules/navigation';
import { useSession } from '../session/session';

/**
 * The modules the person can open, as app icons in the top row of the start page: icon in the
 * accent of the module, name small below. Same modules and order as the sidebar, the company sets
 * the order under Verwaltung › Module (docs/architecture/dashboard.md).
 */
export function ModuleApps() {
  const { t } = useTranslation();
  const session = useSession();
  const modules = useModules();
  const navigation = useMemo(() => buildNavigation(modules, session), [modules, session]);
  if (navigation.length === 0) return null;

  return (
    <nav aria-label={t('shell.modules')} className="mb-6">
      <ul className="grid grid-cols-4 gap-x-2 gap-y-4 md:flex md:flex-wrap md:gap-x-2">
        {navigation.map((module) => (
          <li key={module.id} data-module-accent={module.accent} className="min-w-0 md:w-24">
            <UiLink
              href={module.path}
              className="group flex flex-col items-center gap-2 rounded-md p-1.5 transition-colors transition-fast hover:bg-hover"
            >
              <span className="flex size-12 items-center justify-center rounded-lg border border-line bg-accent-subtle text-accent transition-colors transition-fast group-hover:border-line-strong md:size-14">
                <Icon name={module.icon} className="size-6 md:size-7" />
              </span>
              <span className="line-clamp-2 w-full text-center text-xs break-words hyphens-auto text-fg-muted group-hover:text-fg">
                {t(module.label)}
              </span>
            </UiLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
